// Errors from linking the account in OGC. Both `request_code` (auto-link) and `verify_code`
// can return them, so both steps show the same messages.
// Keys are literal error-code strings the backend returns as array values (not JSON keys
// subject to camelCase inflection), so they must stay snake_case to match.
/* eslint-disable camelcase */
export const LINK_ERROR_MESSAGES = {
  already_linked_to_another_icn: {
    title: 'This registration is already linked',
    body: 'That registration number is already linked to a different account. Contact OGC if you believe this is a mistake.',
  },
  link_failed: {
    title: 'Something went wrong',
    body: 'We couldn’t link your account. Try requesting a new code, or contact OGC if the problem continues.',
  },
};
/* eslint-enable camelcase */
